import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { reducer as formReducer } from 'redux-form';
import authReducer from './Auth/Auth.reducer';
import teamReducer from './Team/Team.reducer';
import manageTeamReducer from './ManageTeams/ManageTeams.reducer';
import invitationReducer from './Invitation/Invitation.reducer';
import memberReducer from './Member/Member.reducer';
import allTasksReducer from './AllTasks/AllTasks.reducer';
import imageUploadReducer from './ImageUpload/ImageUpload.reducer';
import pocReducer from './Poc/Poc.reducer';
import timerReducer from './Timer/Timer.reducer';
import timelineReducer from './Timeline/Timeline.reducer';
import regularizationReducer from './Regularization/Regularization.reducer';
import leaveReducer from './Leave/Leave.reducer';
import planFeaturesReducer from './PlanFeatures/PlanFeatures.reducer';

const rootReducers = (history) =>
  combineReducers({
    router: connectRouter(history),
    auth: authReducer,
    form: formReducer,
    team: teamReducer,
    allTasks: allTasksReducer,
    member: memberReducer,
    manageTeams: manageTeamReducer,
    invitation: invitationReducer,
    taskImage: imageUploadReducer,
    poc: pocReducer,
    timer: timerReducer,
    timeline: timelineReducer,
    regularization: regularizationReducer,
    leave: leaveReducer,
    planFeatures: planFeaturesReducer,
  });

export default rootReducers;
